import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import ImageComponent from "../../component/core/image";
import ImageCommitment from "src/assets/image/our-commitment-page-image/img-commitment.png"

export default function Content() {

    const { t } = useTranslation();

    return (
        <div className='flex flex-col gap-10 max-w-[1280px] mx-auto px-6 py-12 relative w-full'>
            <ImageComponent src={ImageCommitment} alt='image-commitment'
                            className='w-full'
                            height={400} width={480} />
        </div>
    );
}
